var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteAddDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-498.000000, -536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-add-divider",
    transform: "translate(498.000000, 536.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#DCE4F4",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-split_vertical",
    transform: "translate(8.500000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57142857,5.14285714 L4.57142857,2.28571429",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.14285714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.57142857,10.2857143 L4.57142857,7.42857143",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.14285714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.14285714 L9.14285714,5.14285714",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.14285714,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.42857143 L9.14285714,7.42857143",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 1.14285714,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73657143,10.2005714 L4.30228571,11.8885714 C4.45085714,12.0371429 4.692,12.0371429 4.84114286,11.8885714 L6.40685714,10.2005714 C6.57828571,10.0154286 6.44685714,9.71428571 6.19428571,9.71428571 L2.94857143,9.71428571 C2.696,9.71428571 2.56457143,10.0154286 2.73657143,10.2005714 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73657143,2.35942857 L4.30228571,0.671428571 C4.45085714,0.522857143 4.692,0.522857143 4.84114286,0.671428571 L6.40685714,2.35942857 C6.57885714,2.54457143 6.44742857,2.84571429 6.19485714,2.84571429 L2.94857143,2.84571429 C2.696,2.84514286 2.56457143,2.54457143 2.73657143,2.35942857 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteAddDivider);
export default __webpack_public_path__ + "static/media/icon-rte-add-divider.8351b98d7e7908b542e7fd3ff3fd2afd.svg";
export { ForwardRef as ReactComponent };